var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.503 6.70752C20.4939 4.78221 18.9942 3.15072 17.1521 1.97434C15.3101 0.797955 13.1895 0.117415 11 0C8.81052 0.117415 6.68993 0.797955 4.84788 1.97434C3.00582 3.15072 1.5061 4.78221 0.496968 6.70752C0.17166 7.25007 0 7.86922 0 8.5C0 9.13078 0.17166 9.74993 0.496968 10.2925C1.5061 12.2178 3.00582 13.8493 4.84788 15.0257C6.68993 16.202 8.81052 16.8826 11 17C13.1895 16.8826 15.3101 16.202 17.1521 15.0257C18.9942 13.8493 20.4939 12.2178 21.503 10.2925C21.8283 9.74993 22 9.13078 22 8.5C22 7.86922 21.8283 7.25007 21.503 6.70752ZM11.0523 11.9C10.1405 11.9032 9.26479 11.5481 8.61777 10.9128C7.97074 10.2775 7.6054 9.41397 7.60212 8.51224C7.59884 7.6105 7.95788 6.74441 8.60026 6.10449C9.24265 5.46457 10.1158 5.10325 11.0275 5.1H11.0523C11.964 5.1 12.8384 5.45821 13.4831 6.09583C14.1278 6.73346 14.49 7.59826 14.49 8.5C14.49 9.40174 14.1278 10.2665 13.4831 10.9042C12.8384 11.5418 11.964 11.9 11.0523 11.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.39f3a9c63a023c956d9377060761ccad.svg";
export { ForwardRef as ReactComponent };